module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAAAXNSR0IArs4c6QAAAMRJREFUKFPF0rEqhgEUBuDn2E1ugE2YjQY3wGC0iFImSsoVKCkmpcgNGLgBg9GMbMzKZPfy1ffpH376+hdnPec59Z5OJVnFKcb1qw9sVZI3nOO+nzOPjQYGs1X11AcmmcFjB9+xj4uq+hy2IMkY1nGAiQ6eYQ3P2Kmq20GcZBHHmMYlNjs4hcIhVnCD3RYfYQlX2EMT7eUHVtVrM5hkASffg3MtfMB2Vd21/cmhsG02eZZbeD2YO8nv8K/r/i8c+XNG+tUvCot4ajVLypwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emaill.png
// module id = 0mlx
// module chunks = 16